import React, { useEffect } from "react";
import { useParams } from "react-router";
import NewNewProductPage from "./product/NewNewProductPage";

const CONFIG = {
  hr: {
    title: "Tečajevi stranih jezika temeljeni na stvarnim situacijama",
    description: "Uči kroz životne situacije, uz uvide izvornih govornika.",
  },
};

const ProductPage = ({ data }) => {
  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
    document.getElementsByName("description")[0].content =
      CONFIG[lang]?.description;
  }, [lang]);

  return <NewNewProductPage data={data.product_page} />;
};

export default ProductPage;
